import { Flex, Typography } from '@aloft/toolkit-sui';

import { MaybeTooltip } from './utils/MaybeTooltip.tsx';

type TotalLineProps = {
  label: string;
  value: string;
  extra?: string;
  subTotal?: boolean;
  tooltipContent?: string[];
};

export const TotalLine = ({
  label,
  value,
  extra = '',
  subTotal = false,
  tooltipContent = [],
}: TotalLineProps) => {
  const variant = subTotal ? 'h4' : 'h3';
  const color = 'textPrimary';
  const tooltipLabel =
    tooltipContent.length > 0 ? (
      <Flex flexDirection="column" gap="1rem">
        {tooltipContent.map((paragraph, idx) => (
          <Typography key={`tooltip-${idx}`} variant="body1" color="textOffset">
            {paragraph}
          </Typography>
        ))}
      </Flex>
    ) : undefined;

  return (
    <Flex justifyContent="space-between">
      <MaybeTooltip hasArrow openDelay={2000} placement="top" label={tooltipLabel}>
        <Flex alignItems="center" gap="0.5rem">
          <Typography variant={variant} color={color}>
            {label}
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {extra}
          </Typography>
        </Flex>
      </MaybeTooltip>
      <MaybeTooltip hasArrow openDelay={200} placement="top" label={tooltipLabel}>
        <Typography variant={variant} color={color}>
          {value}
        </Typography>
      </MaybeTooltip>
    </Flex>
  );
};
